<form class="card filters no-print" (ngSubmit)="apply.emit()" aria-describedby="period-active-label period-week-help">
  <div class="filter-copy">
    <span>Período do fechamento</span>
    <strong>Escolha um mês salvo ou monte um período manual</strong>
  </div>

  <div class="filters-grid">
    <div class="field month-field">
      <label for="dashboard-month">Mês</label>
      <select id="dashboard-month" name="month" [value]="selectedMonth" (change)="monthChange.emit($any($event.target).value)" [disabled]="busy">
        <option value="manual">Período manual</option>
        @for (month of monthOptions; track month.month) {
        <option [value]="month.month">{{ month.month }}{{ month.complete ? ' · completo' : month.hasMlData || month.hasMpData ? ' · parcial' : ' · sem dados' }}</option>
        }
      </select>
    </div>
    <div class="field">
      <label for="dashboard-start-date">Data inicial</label>
      <input id="dashboard-start-date" name="startDate" type="date" [value]="startDate" (input)="startDateChange.emit($any($event.target).value)" />
    </div>
    <div class="field">
      <label for="dashboard-end-date">Data final</label>
      <input id="dashboard-end-date" name="endDate" type="date" [value]="endDate" (input)="endDateChange.emit($any($event.target).value)" />
    </div>
    <div class="filters-actions">
      <button class="btn btn-primary" type="submit" [disabled]="busy">{{ busy ? 'Carregando...' : 'Ver este período' }}</button>
      <button class="btn btn-secondary" type="button" (click)="resetDefault.emit()">Semana padrão</button>
    </div>
  </div>

  <div class="filters-footer">
    <p id="period-active-label" class="period-label">Período ativo: {{ activePeriodLabel }}</p>
    @if (monthStatusLabel) {
    <p class="month-status">{{ monthStatusLabel }}</p>
    }
    <p id="period-week-help" class="week-help">{{ standardWeekHelp }}</p>
  </div>
</form>
